import React from 'react';
import { ThemeProvider } from 'styled-components';
import { themes } from '../../ui/design-tokens';
import OImage from '../OImage';

import { Module, Container, ImageZone, Top, Block } from './styles';
import Wrapper from '../../ui/Wrappers';
import { getSrcset, externalLink } from '../../ui/helpers';
interface IBlocks {
  key?: string;
  theme: string;
  bigText?: string;
  smallText?: string;
  prefix?: string;
  imageUrl?: string[];
}

interface IProps {
  theme?: string;
  heading: string;
  title?: string;
  subtitle?: string;
  blocks: IBlocks[];
  isHome?: boolean;
  imageUrl?: any;
  imageAlt?: string;
}

const HomeKPI = ({
  theme,
  heading,
  title,
  subtitle,
  blocks,
  imageUrl,
  imageAlt,
  isHome = false
}: IProps) => {
  const moduleTheme = theme ? theme : 'white';
  imageUrl = null;
  
  return (
    <Module moduleTheme={themes.basic[moduleTheme]}>
      {title && (
        <Wrapper fullwidth={true} size="reader" as={Top} isHome={isHome}>
          {title &&
            (heading === 'heading_2' ? (
              <h2 className="title">{title}</h2>
            ) : (
              <h3 className="title">{title}</h3>
            ))}

          {subtitle && <p className="subtitle">{subtitle}</p>}
        </Wrapper>
      )}
      <ImageZone>
        {imageUrl && (
          <OImage
            src={imageUrl.original?.href}
            aspectRatio={imageUrl.original?.meta.width / imageUrl.original?.meta.height}
            srcSet={getSrcset(imageUrl)}
            webp={getSrcset(imageUrl, true)}
            alt={imageAlt || ''}
            className="image"
          />
        )}
      </ImageZone>
      <Wrapper fullwidth={true} as={Container} size="mainwrapper">
        {blocks.map((block, index) => {
          const cleanedTheme = block.theme ? block.theme : 'white';
          let splittedUrl, imageName, query, baseUrl, finalUrl;

          const customEncodeURIComponent = (str) => {
            return encodeURIComponent(str)
              .replace(/\(/g, '%28')
              .replace(/\)/g, '%29')
              .replace(/'/g, '%27')
              .replace(/!/g, '%21')
              .replace(/\*/g, '%2A');
          };

          const getImageUrl = (links, size) => {
            if (links && links[size] && links[size].href) {
              return links[size].href;
            }
            return null;
          };

          const href = getImageUrl(block?.imageUrl, 'xsmall_webp')
            || getImageUrl(block?.imageUrl, 'xsmall');

          if (href) {
            splittedUrl = href.split('/');
            imageName = splittedUrl[splittedUrl.length - 1];
            query = imageName.split('?')[1];
            baseUrl = href.replace(imageName, '');
            imageName = imageName.replace('?' + query, '');
            finalUrl = baseUrl + customEncodeURIComponent(imageName) + '?' + query;
          }

          return (
            <ThemeProvider theme={themes.basic[cleanedTheme]}>
              <Block key={block.key}>
                <span className="big" style={{ display: block.prefix === 'null' ? 'none' : 'inline' }}>
                  <span className="prefix">{block.prefix}</span>
                  {block.bigText}
                </span>
                <div className='imageContainer'>
                  <img className={index === 0 ? 'personImage' : index === 1 ? 'homeImage' : index === 2 ? 'heartImage' : ''} src={finalUrl} />
                </div>
                <p className="small" style={{ display: 'none' }}>{block.smallText}</p>
              </Block>
            </ThemeProvider>
          );
        })}
      </Wrapper>
    </Module>
  );
};

export default HomeKPI;
